import { $doc } from "../utils/globals";

const $input = $('.js-field-quantity input[type=number]');

$('.js-decrease').click(function () {
  var count = parseInt($input.val()) - 1;
  count = count < 1 ? 1 : count;
  $input.val(count);
  $input.change();
  return false;
});
$('.js-increase').click(function () {
  $input.val(parseInt($input.val()) + 1);
  $input.change();
  return false;
});
